/**
 * Auth store. После H4 фронт НЕ хранит JWT сам - токен живёт в HttpOnly
 * cookie, которую браузер сам шлёт на /api/* (credentials: 'include')
 * Здесь остаётся только профиль пользователя для UI.
 *
 * legacy `token` поле сохранено как nullable для обратной совместимости со
 * старыми компонентами, которые могли его читать; новые НЕ читают
 *
 * При первой инициализации модуль вычищает залежавшийся localStorage,
 * чтобы старый XSS-уязвимый токен не «зомби-логинил» юзера после H4.
 */
import { create } from "zustand";

export interface CurrentUser {
  id: string;
  email: string;
  role: "user" | "admin";
  balance: number;
  display_name?: string;
  /** Гостевой вход: нельзя пополнять баланс, при 0 кредитов предлагаем
   * зарегистрироваться. */
  is_guest?: boolean;
}

interface AuthState {
  user: CurrentUser | null;
  /** true после первой попытки загрузить /api/auth/me (успех ИЛИ 401)
   * RequireAuth использует флаг чтобы не мигать redirect'ом во время
   * первоначальной проверки сессии. */
  authChecked: boolean;
  /** @deprecated cookie-based auth - токен не нужен на фронте. */
  token: string | null;
  setUser: (u: CurrentUser | null) => void;
  setAuthChecked: (v: boolean) => void;
  /** @deprecated no-op (cookie set by backend). Оставлен чтобы старые
   *  вызовы (например, useAuthFlow) не падали с TypeError. */
  setToken: (t: string | null) => void;
  logout: () => void;
}

// One-time cleanup от предыдущей реализации хранения токена в localStorage.
if (typeof window !== "undefined") {
  try { localStorage.removeItem("crystal-ai.token"); } catch { /* ignore */ }
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  authChecked: false,
  token: null,
  setUser: (u) => set({ user: u, authChecked: true }),
  setAuthChecked: (v) => set({ authChecked: v }),
  setToken: () => {/* no-op, cookie owns session now */},
  logout: () => {
    // Cookie чистит backend (POST /api/auth/logout). Здесь сбрасываем UI.
    set({ user: null, token: null, authChecked: true });
  },
}));
